// Shipping label printer — A4, 6 labels per page
export function printShippingLabels(orders) {
  if (!orders.length) return;

  const sorted = [...orders].sort((a, b) => {
    const aBook = a.items?.[0]?.bt || a.items?.[0]?.bookTitle || '';
    const bBook = b.items?.[0]?.bt || b.items?.[0]?.bookTitle || '';
    return aBook.localeCompare(bBook);
  });

  const labelHtml = sorted.map((order) => {
    const delivery = order.delivery || {};
    const name = delivery.name || order.studentName || 'Customer';
    const phone = delivery.phone || order.studentPhone || '';
    const altPhone = delivery.altPhone || '';
    const address = delivery.address || [delivery.street, delivery.postOffice, delivery.district, delivery.state].filter(Boolean).join(', ') + (delivery.pincode ? ' - ' + delivery.pincode : '');
    const items = order.items || [];
    const totalUnits = items.reduce((s, i) => s + Number(i.qty || 1), 0);
    const orderDate = order.createdAt ? new Date(order.createdAt).toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' }) : '';

    const itemRows = items.map((item) =>
      `<tr>
        <td style="padding:3px 6px;border:1px solid #999;font-size:10px">${item.bt || item.bookTitle || '—'}</td>
        <td style="padding:3px 6px;border:1px solid #999;font-size:10px;white-space:nowrap">${item.vn || item.variantName || ''}</td>
        <td style="padding:3px 6px;border:1px solid #999;font-size:10px;text-align:center">${item.qty || 1}</td>
      </tr>`
    ).join('');

    return `
<div class="label">
  <div class="label-header">
    <div class="label-brand">MUPPADAI TRAINING ACADEMY</div>
    <div class="label-meta">
      <span class="label-orderid">${order.orderId || order.id}</span>
      <span class="label-date">${orderDate} &bull; ${totalUnits} book${totalUnits !== 1 ? 's' : ''}</span>
    </div>
  </div>
  <div class="label-deliver">
    <div class="label-deliver-title">DELIVER TO</div>
    <div class="label-name">${name}</div>
    <div class="label-phone">${phone}${altPhone ? ' / ' + altPhone : ''}</div>
    <div class="label-address">${address}</div>
  </div>
  <div class="label-items">
    <table style="width:100%;border-collapse:collapse;font-size:10px">
      <thead><tr>
        <th style="padding:3px 6px;border:1px solid #999;background:#f0f0f0;font-size:9px;text-align:left">Book Title</th>
        <th style="padding:3px 6px;border:1px solid #999;background:#f0f0f0;font-size:9px;text-align:left">Variant</th>
        <th style="padding:3px 6px;border:1px solid #999;background:#f0f0f0;font-size:9px;text-align:center">Qty</th>
      </tr></thead>
      <tbody>${itemRows}</tbody>
    </table>
  </div>
</div>`;
  }).join('');

  const html = `<!DOCTYPE html>
<html>
<head>
<meta charset="UTF-8"/>
<title>Shipping Labels — Muppadai Training Academy</title>
<style>
  * { box-sizing: border-box; margin: 0; padding: 0; }
  @page { size: A4; margin: 10mm; }
  body { font-family: Arial, sans-serif; background: #fff; }
  .page-header { text-align: right; font-size: 11px; color: #666; margin-bottom: 8px; }
  .labels-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 6mm;
  }
  .label {
    border: 2.5px solid #111;
    border-radius: 4px;
    padding: 8px 10px;
    page-break-inside: avoid;
    break-inside: avoid;
    display: flex;
    flex-direction: column;
    gap: 6px;
    min-height: 90mm;
  }
  .label-header {
    border-bottom: 1.5px solid #111;
    padding-bottom: 5px;
    display: flex;
    flex-direction: column;
    gap: 3px;
  }
  .label-brand {
    font-size: 11px;
    font-weight: 800;
    letter-spacing: 0.03em;
    color: #111;
  }
  .label-meta {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 6px;
  }
  .label-orderid {
    font-size: 16px;
    font-weight: 900;
    color: #000;
    letter-spacing: 0.02em;
  }
  .label-date {
    font-size: 10px;
    color: #444;
  }
  .label-deliver {
    display: flex;
    flex-direction: column;
    gap: 2px;
    border-bottom: 1px dashed #999;
    padding-bottom: 6px;
  }
  .label-deliver-title {
    font-size: 9px;
    font-weight: 700;
    letter-spacing: 0.08em;
    color: #555;
    text-transform: uppercase;
    margin-bottom: 2px;
  }
  .label-name {
    font-size: 13px;
    font-weight: 700;
    color: #000;
  }
  .label-phone {
    font-size: 11px;
    color: #222;
    font-weight: 600;
  }
  .label-address {
    font-size: 10px;
    color: #333;
    line-height: 1.4;
  }
  .label-items {
    flex: 1;
  }
  .print-btn {
    position: fixed;
    top: 16px;
    right: 16px;
    background: #2F338C;
    color: #fff;
    border: none;
    padding: 10px 24px;
    border-radius: 8px;
    font-size: 14px;
    font-weight: 700;
    cursor: pointer;
    z-index: 9999;
  }
  @media print {
    .print-btn { display: none; }
    body { background: #fff; }
  }
</style>
</head>
<body>
<button class="print-btn" onclick="window.print()">🖨️ Print Labels</button>
<div class="page-header">Muppadai Training Academy — ${sorted.length} label${sorted.length !== 1 ? 's' : ''} — ${new Date().toLocaleDateString('en-IN')}</div>
<div class="labels-grid">
${labelHtml}
</div>
</body>
</html>`;

  const win = window.open('', '_blank', 'width=900,height=700');
  win.document.write(html);
  win.document.close();
}
